module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "title-frontMatter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466828674_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUTHOR’S PREFACE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("It isn’t easy to put all the tales of Sam Gunn together in any sequence that even vaguely resembles chronological order. Sam’s various tales are spread all over the solar system (and even beyond) and span a lifetime filled with adventure, romance, and more than a little trickery.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I’ve done my best. I’ve sifted through all the stories about Sam Gunn and even added a couple of new ones. It’s been tricky, though. In the pages of this book, Sam’s life story is told from its beginning to the present moment. Please don’t expect exact chronological order or a well-defined sequence of events. Sam is far too clever to be pinned down like an ordinary person.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("All I can offer, at this point, is a quotation from a much better writer than I, Mr. Samuel Clemens, aka Mark Twain:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Persons attempting to find a motive in this narrative will be prosecuted; persons attempting to find a moral in it will be banished; persons attempting to find a plot in it will be shot.")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I suggest you merely read the stories and enjoy them. Trying to make order out of the chaotic events of Sam Gunn’s life can drive you to drink. That’s one of the things that I like about Sam.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("BEN BOVA")])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Naples, Florida")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("January 2006")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669a5ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466828674_fm01.vue
// module id = 75
// module chunks = 0